import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Bill = ({
  size,
  type,
  theme,
  className,
  dataTestId = "bill-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M5.33333 5.55188C5.33333 5.18369 5.63181 4.88521 6 4.88521H10C10.3682 4.88521 10.6667 5.18369 10.6667 5.55188C10.6667 5.92007 10.3682 6.21855 10 6.21855H6C5.63181 6.21855 5.33333 5.92007 5.33333 5.55188Z" />
    <path d="M6 7.79928C5.63181 7.79928 5.33333 8.09775 5.33333 8.46594C5.33333 8.83413 5.63181 9.13261 6 9.13261H10C10.3682 9.13261 10.6667 8.83413 10.6667 8.46594C10.6667 8.09775 10.3682 7.79928 10 7.79928H6Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2.33313C2 1.22856 2.89543 0.33313 4 0.33313H12C13.1046 0.33313 14 1.22856 14 2.33313V14.9998C14 15.2358 13.8753 15.4541 13.672 15.574C13.4688 15.6939 13.2173 15.6974 13.0108 15.5833L11.5556 14.7789L10.4228 15.405C10.0214 15.6269 9.53416 15.6269 9.13277 15.405L8 14.7789L6.86723 15.405C6.46584 15.6269 5.9786 15.6269 5.57721 15.405L4.44444 14.7789L2.98917 15.5833C2.78266 15.6974 2.5312 15.6939 2.32796 15.574C2.12473 15.4541 2 15.2358 2 14.9998V2.33313ZM4 1.66646C3.63181 1.66646 3.33333 1.96494 3.33333 2.33313V13.8696L3.79943 13.6119C4.20082 13.3901 4.68807 13.3901 5.08946 13.6119L6.22222 14.2381L7.35499 13.6119C7.75638 13.3901 8.24362 13.3901 8.64501 13.6119L9.77778 14.2381L10.9105 13.6119C11.3119 13.3901 11.7992 13.3901 12.2006 13.6119L12.6667 13.8696V2.33313C12.6667 1.96494 12.3682 1.66646 12 1.66646H4Z"
    />
  </SVGIcon>
);
